module.exports = __webpack_public_path__ + "img/chehulu1.e5153b4f.jpg";